import { useContext } from "react";
import { Context } from ".";

const useFetchContext = () => {
	const fetchContext = useContext(Context);
	return fetchContext;
};

export default useFetchContext;
